import { Redirect, Route, RouteProps } from 'react-router-dom';
import React from 'react';
import { useRecoilValue } from 'recoil';
import { IsAuthorized } from '../Recoil/Atoms';
import { RouteUrls } from './RouteUrls';

export interface IRoutePrivateProps extends RouteProps {}

const RoutePrivate: React.FC<IRoutePrivateProps> = (props) => {
    const authorized = useRecoilValue(IsAuthorized);

    return authorized ? (
        <Route>{props.children}</Route>
    ) : (
        <Redirect
            to={{
                pathname: RouteUrls.Login,
                state: { from: props.location },
            }}
        />
    );
};

export { RoutePrivate };
